module.exports = __webpack_public_path__ + "img/building95-1.2f5021a0.jpg";